export default {"src":"https://fishbrain.com/_next/static/media/grouper.52109c1c.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};